<template>
    <div class="bodyClass">
        <table width="100%">
            <tr align="center">
                <td>
                    <table width="100%">
                        <tr>
                            <td width="60%" align="right"><h1>综合统计【{{ title }}】</h1></td>
                            <td>
                                <a-range-picker class="mr-20" :mode="mode2" format="YYYY-MM" @change="MonthOnChange"
                                    @panelChange="handlePanelChange" :value="createValue"
                                    :placeholder="['开始月份', '结束月份']" />
                            </td>
                            <td align="right">
                                <a-button class="mr-20 view-btn large" html-type="submit"
                                    @click="stat()">搜索</a-button>&nbsp;&nbsp;
                                <a-button class="mr-20 view-btn large" html-type="submit" @click="reset">重置</a-button>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td>
                    <a-table :columns="columns" :dataSource="list" :rowKey="(record) => record.dept_id"
                        :pagination="false">
                        <template slot="showDetail1" slot-scope="text, record">
                            <div @click="showDetail(record.dept_id,false)" class="detailClass">{{ text }}</div>
                            <div @click="showDetail(record.dept_id,true)" class="exportClass"><a-icon type="file-excel"/>导出</div>
                        </template>
                        <template slot="showDetail2" slot-scope="text, record">
                            <div @click="showDetail2(false,record.dept_id)"  class="detailClass">{{ text }}</div>
                            <div @click="showDetail2(true,record.dept_id)" class="exportClass"><a-icon type="file-excel" />导出</div>
                        </template>
                        <template slot="showDetail3" slot-scope="text, record">
                            <div @click="showDetail2(false,record.dept_id, 0)"  class="detailClass">{{ text }}</div>
                            <div @click="showDetail2(true,record.dept_id, 0)" class="exportClass"><a-icon type="file-excel" />导出</div>
                        </template>
                        <template slot="showDetail4" slot-scope="text, record">
                            <div @click="showDetail2(false,record.dept_id, 1)"  class="detailClass">{{ text }}</div>
                            <div @click="showDetail2(true,record.dept_id, 1)" class="exportClass"><a-icon type="file-excel" />导出</div>
                        </template>
                        <template slot="showDetail5" slot-scope="text, record">
                            <div @click="showDetail2(false,record.dept_id, 2)"  class="detailClass">{{ text }}</div>
                            <div @click="showDetail2(true,record.dept_id, 2)" class="exportClass"><a-icon type="file-excel" />导出</div>
                        </template>
                        <template slot="showDetail6" slot-scope="text, record">
                            <div @click="showDetail2(false,record.dept_id, 1, 1)"  class="detailClass">{{ text }}</div>
                            <div @click="showDetail2(true,record.dept_id, 1, 1)" class="exportClass"><a-icon type="file-excel" />导出</div>
                        </template>
                    </a-table>
                </td>
            </tr>
            <tr>
                <td>
                    <div id="main" style="width: 100%; height: 400px; background: gray"></div>
                </td>
            </tr>
        </table>
        <a-modal centered :title="'【' + getDeptName(deptId) + '】执行单'" v-model="showImpl" :zIndex="2" width="1700px"
            :maskClosable="false" @ok="showImpl = false">
            <div style="min-height:600px">
                <!-- <div class="filter-panel">
                    <a-row>
                        <a-col :span="24" class="other-filter">
                            <div class="mr-20">关键字:</div>
                            <a-input class="mr-20" placeholder="关键字" style="width: 360px" v-model="keyword2" />
                            <div class="mr-20">物料名称:</div>
                            <a-select class="mr-20" style="width: 240px" v-model="materialName" placeholder="物料名称">
                                <a-select-option v-for="o in materials" :value="o" :key="o">{{ o }}</a-select-option>
                            </a-select>
                            <a-button class="mr-20 view-btn large" html-type="submit" @click="openImple">搜索</a-button>
                            <a-button class="mr-20 view-btn large" html-type="submit" @click="reset2">重置</a-button>
                        </a-col>
                    </a-row>
                </div> -->
                <a-table :columns="columns1" :dataSource="list1" :rowKey="(record) => record.id"
                    :scroll="{ x: 1500, y: 600 }" v-if="list1 && list1.length > 0" :pagination="pagination1"
                    @change="onPageChange1">
                    <template slot="showTitle2" slot-scope="text, record" ellipsis="...">
                        <div :title="text" style="white-space: pre-wrap;">{{ getDeptName(text) }}</div>
                    </template>
                    <template slot="showTitle" slot-scope="text, record" ellipsis="...">
                        <div :title="text" style="white-space: pre-wrap;">{{ text }}</div>
                    </template>
                </a-table>
            </div>
        </a-modal>

        <a-modal centered :title="'【' + getDeptName(deptId) + '】发(到)货记录'" v-model="showInvoice" :zIndex="2"
            width="1700px" :maskClosable="false" @ok="showInvoice = false">
            <div style="min-height:600px">
                <a-table :columns="columns2" :dataSource="list2" :rowKey="(record) => record.id"
                    :scroll="{ x: 1500, y: 600 }" v-if="list2 && list2.length > 0" :pagination="pagination2"
                    @change="onPageChange2" :rowClassName="rowClass">
                    <template slot="showStatus" slot-scope="text, record">
                        <div :title="text">{{ getStatus(record.b_status) }}</div>
                    </template>
                    <template slot="countDown" slot-scope="text, record" ellipsis="...">
                        <div :title="text" style="white-space: pre-wrap;">{{ countDown2(record) }}</div>
                    </template>
                    <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
                    <table width="95%">
                        <tr :class="rowClass(record)">
                            <td width="23%">
                                <span class="childCss">计划发（到）货时间：</span>
                                <strong>
                                    {{ moment(record.b_plan_start).format("YYYY-MM-DD") }}
                                    ~{{ moment(record.b_plan_end).format("YYYY-MM-DD") }}
                                </strong>
                            </td>
                            <td width="7%">
                                <span class="childCss">数量：</span><strong>{{ record.b_num }}</strong>
                            </td>
                            <td width="25%">
                                <span class="childCss">地点：</span><strong>{{ record.b_address }}</strong>
                            </td>
                            <td width="9%">
                                <span class="childCss">联系人：</span><strong>{{ record.b_linkman }}</strong>
                            </td>
                            <td width="14%">
                                <span class="childCss">联系电话：</span><strong>{{ record.b_linkphone }}</strong>
                            </td>
                            <td>
                                <span class="childCss">备注说明：</span><strong>{{ record.b_remark }}</strong>
                            </td>
                        </tr>
                    </table>
                    </p>
                </a-table>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { statistics_stat, statistics_detail } from "@/api";
import echarts from 'echarts';
import moment from "moment";
export default {
    components: {
    },
    data() {
        return {
            title: "2024-03起",
            moment,
            mode2: ['date', 'date'],
            list: [],
            columns: [
                {
                    title: "检测机构",
                    width: 100,
                    dataIndex: "deptName",
                    key: "deptName"
                },
                {
                    title: "执行单",
                    width: 100,
                    dataIndex: "imple_count",
                    key: "imple_count",
                    scopedSlots: { customRender: "showDetail1" },
                },
                {
                    title: "发(到)货记录",
                    width: 100,
                    dataIndex: "invoice_count",
                    key: "invoice_count",
                    scopedSlots: { customRender: "showDetail2" },
                },
                {
                    title: "待抽检",
                    width: 100,
                    dataIndex: "daichoujian",
                    key: "daichoujian",
                    scopedSlots: { customRender: "showDetail3" },
                },
                {
                    title: "已抽检",
                    width: 100,
                    dataIndex: "yichoujian",
                    key: "yichoujian",
                    scopedSlots: { customRender: "showDetail4" },
                },
                {
                    title: "已覆盖",
                    width: 100,
                    dataIndex: "yifugai",
                    key: "yifugai",
                    scopedSlots: { customRender: "showDetail5" },
                },
                {
                    title: "已上传报告",
                    width: 100,
                    dataIndex: "baogao",
                    key: "baogao",
                    scopedSlots: { customRender: "showDetail6" },
                }],
            isShowChart: false,
            hpData: [0, 0, 0, 0, 0, 0],
            hnData: [0, 0, 0, 0, 0, 0],
            createValue: [],

            deptId: undefined,
            // 执行单
            showImpl: false,
            columns1: [
                {
                    title: "检测机构",
                    width: 70,
                    dataIndex: "x_dept_id",
                    key: "x_dept_id",
                    scopedSlots: { customRender: "showTitle2" },
                },
                {
                    title: "供应商名称",
                    width: 200,
                    dataIndex: "fullUnitName",
                    key: "fullUnitName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "报装编号",
                    width: 100,
                    dataIndex: "bzNo",
                    key: "bzNo",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "工程项目名称",
                    width: 300,
                    dataIndex: "projectName",
                    key: "projectName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "物料名称",
                    width: 150,
                    dataIndex: "materialName",
                    key: "materialName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "型号规格",
                    width: 150,
                    dataIndex: "model",
                    key: "model",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "数量",
                    width: 70,
                    dataIndex: "num",
                    key: "num",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "单位",
                    width: 70,
                    dataIndex: "unit",
                    key: "unit",
                },
                {
                    title: "记录人",
                    width: 90,
                    dataIndex: "userName",
                    key: "userName",
                }
            ],
            queryParams1: {
                limit: 10,
                page: 0,
                searchCondition: {},
            },
            list1: [],
            pagination1: {
                total: 0,
                current: 1,
                showTotal: (total) => {
                    return `共 ${total} 条`;
                },
            },

            // 发到货记录
            showInvoice: false,
            columns2: [
                {
                    title: "检测机构",
                    width: 70,
                    dataIndex: "deptName",
                    key: "deptName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "供应商名称",
                    width: 150,
                    dataIndex: "a_fullUnitName",
                    key: "a_fullUnitName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "报装编号",
                    width: 100,
                    dataIndex: "a_bzNo",
                    key: "a_bzNo",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "工程项目名称",
                    width: 300,
                    dataIndex: "a_projectName",
                    key: "a_projectName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "物料名称",
                    width: 150,
                    dataIndex: "a_materialName",
                    key: "a_materialName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "型号规格",
                    width: 150,
                    dataIndex: "a_model",
                    key: "a_model",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "数量",
                    width: 70,
                    dataIndex: "a_num",
                    key: "a_num",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "单位",
                    width: 70,
                    dataIndex: "a_unit",
                    key: "a_unit",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "状态",
                    width: 70,
                    dataIndex: "b_status",
                    key: "b_status",
                    scopedSlots: { customRender: "showStatus" },
                },
                {
                    title: "记录人",
                    width: 90,
                    dataIndex: "a_userName",
                    key: "a_userName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "打印计时（天）",
                    width: 90,
                    dataIndex: "b_checked_at",
                    key: "count_down",
                    scopedSlots: { customRender: "countDown" },
                }],
            queryParams2: {
                limit: 10,
                page: 0,
                searchCondition: {},
            },
            list2: [],
            pagination2: {
                total: 0,
                current: 1,
                showTotal: (total) => {
                    return `共 ${total} 条`;
                },
            },
            status: undefined,
            report: undefined,
        };
    },
    mounted() {
        this.stat();
    },
    methods: {
        reset() {
            this.title = "2024-03起";
            this.list = [];
            this.hpData = [0, 0, 0, 0, 0, 0];
            this.hnData = [0, 0, 0, 0, 0, 0];
            this.createValue = [];

            this.stat();
        },
        stat() {
            let that = this;
            this.isShowChart = false;
            let opt = {};
            if (this.createValue && this.createValue.length == 2) {
                opt.start = moment(this.createValue[0]).format("YYYY-MM");
                opt.end = moment(this.createValue[1]).format("YYYY-MM");
                this.title = opt.start + "至" + opt.end;
            }
            this.list = [];
            this.hpData = [0, 0, 0, 0, 0, 0];
            this.hnData = [0, 0, 0, 0, 0, 0];
            statistics_stat(opt).then((res) => {
                // console.log("success" + JSON.stringify(res) );
                that.list = res;
                for (var i in res) {
                    console.log(res[i]);
                    var item = res[i];
                    if (item.dept_id === 112) {
                        that.hpData[0] = item.imple_count;
                        that.hpData[1] = item.invoice_count;
                        that.hpData[2] = item.daichoujian;
                        that.hpData[3] = item.yichoujian;
                        that.hpData[4] = item.yifugai;
                        that.hpData[5] = item.baogao;
                    } else if (item.dept_id === 134) {
                        that.hnData[0] = item.imple_count;
                        that.hnData[1] = item.invoice_count;
                        that.hnData[2] = item.daichoujian;
                        that.hnData[3] = item.yichoujian;
                        that.hnData[4] = item.yifugai;
                        that.hnData[5] = item.baogao;
                    }
                }
                that.showChart();
            }).finally((res) => { })
        },
        showChart() {
            var myChart = echarts.init(document.getElementById("main"));
            var option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                xAxis: {
                    type: "category",
                    data: ["执行单", "发(到)货记录", "待抽检", "已抽检", "已覆盖", "已出具报告"],
                },
                yAxis: {},
                series: [
                    {
                        type: "bar",
                        name: "黄陂",
                        data: this.hpData,
                    },
                    {
                        type: "bar",
                        name: "汉南",
                        data: this.hnData,
                    }
                ],
            };
            console.log(this.hpData);
            console.log(this.hnData);
            myChart.setOption(option);
            this.isShowChart = true;
        },
        MonthOnChange(date) {
            this.createValue = date;
        },
        handlePanelChange(val, mode) {
            this.createValue = val;
            // this.mode2 = [
            //     mode[0] === 'date' ? 'month' : mode[0],
            //     mode[1] === 'date' ? 'month' : mode[1],
            // ];
        },
        showDetail(deptId,isExport) {
            this.deptId = deptId;
            this.pagination1 = {
                total: 0,
                current: 1,
                showTotal: (total) => {
                    return `共 ${total} 条`;
                },
            };
            this.queryParams1 = {
                limit: 10,
                page: 0,
                searchCondition: {},
            };
            this.list1 = [];
            this.getDetailList(isExport);
        },
        getDetailList(isExport) {
            this.queryParams1.searchCondition.deptId = this.deptId;
            this.queryParams1.searchCondition.type = 'imple';
            if (this.createValue && this.createValue.length == 2) {
                this.queryParams1.searchCondition.start = moment(this.createValue[0]).format("YYYY-MM");
                this.queryParams1.searchCondition.end = moment(this.createValue[1]).format("YYYY-MM");
            } else {
                delete this.queryParams1.searchCondition.start;
                delete this.queryParams1.searchCondition.end;
            }
            if( isExport ) {
                this.queryParams1.searchCondition.isExport = isExport;
            } else {
                delete this.queryParams1.searchCondition.isExport;
            }
            statistics_detail(this.queryParams1)
                .then((res) => {
                    if( isExport ) {
                        window.open(res);
                    } else {
                        this.list1 = res.list;
                        this.pagination1.total = res.total;
                    }
                })
                .finally((res) => {
                    if( !isExport ) {
                        this.showImpl = true;
                    }
                });
        },
        onPageChange1(pagination, filters, sorter) {
            this.pagination1 = pagination;
            this.queryParams1.page = pagination.current - 1;
            this.getDetailList();
        },
        getDeptName(deptId) {
            if (deptId == 112) {
                return "黄陂";
            } else if (deptId == 134) {
                return "汉南";
            }
            return "未分配";
        },

        showDetail2(isExport,deptId, status, report) {
            this.deptId = deptId;
            this.status = status;
            this.report = report;
            this.pagination2 = {
                total: 0,
                current: 1,
                showTotal: (total) => {
                    return `共 ${total} 条`;
                },
            };
            this.queryParams2 = {
                limit: 10,
                page: 0,
                searchCondition: {},
            };
            this.list2 = [];
            this.getDetailList2(isExport);
        },
        getDetailList2(isExport) {
            this.queryParams2.searchCondition.deptId = this.deptId;
            this.queryParams2.searchCondition.type = 'invoice';
            this.queryParams2.searchCondition.status = this.status;
            this.queryParams2.searchCondition.report = this.report;
            if (this.createValue && this.createValue.length == 2) {
                this.queryParams2.searchCondition.start = moment(this.createValue[0]).format("YYYY-MM");
                this.queryParams2.searchCondition.end = moment(this.createValue[1]).format("YYYY-MM");
            } else {
                delete this.queryParams2.searchCondition.start;
                delete this.queryParams2.searchCondition.end;
            }
            if( isExport ) {
                this.queryParams2.searchCondition.isExport = isExport;
            } else {
                delete this.queryParams2.searchCondition.isExport;
            }
            statistics_detail(this.queryParams2)
                .then((res) => {
                    if( isExport ) {
                        window.open(res);
                    } else {
                        this.list2 = res.list;
                        this.pagination2.total = res.total;
                    }
                })
                .finally((res) => {
                    if( !isExport ) {
                        this.showInvoice = true;
                    }
                });
        },
        onPageChange2(pagination, filters, sorter) {
            this.pagination2 = pagination;
            this.queryParams2.page = pagination.current - 1;
            this.getDetailList2();
        },
        rowClass(record) {
            // console.log(record.b_status);
            if (record.b_status == 1) {
                return "checkClass";
            } else if (record.b_status == 2) {
                return "coverClass";
            } else {
                return "";
            }
        },
        countDown(text) {
            let now = moment().format("YYYY-MM-DD");
            let date = moment(text).format("YYYY-MM-DD");
            let str = moment(now).diff(moment(date), 'days');
            return str;
        },
        countDown2(record) {
            let text = record.b_checked_at;
            let str = this.countDown(text);
            let b_check_result = record.b_check_result;
            let b_rectify_result = record.b_rectify_result;
            if (b_rectify_result == 2) {
                return "整改不合格";
            } else if (b_rectify_result == 1) {
                return "可打印";
            } else {
                if (b_check_result == 2) {
                    return "整改中";
                }
            }
            return str >= 10 ? '可打印' : str;
        },
        getStatus(b_status) {
            if (b_status == 1) {
                return "抽检";
            } else if (b_status == 2) {
                return "覆盖";
            } else {
                return "初始";
            }
        },
    }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.bodyClass {
    font-size: 18px;
}
</style>
<style>
.checkClass {
    color: orange;
}

.coverClass {
    color: blue;
}
.detailClass {
    cursor:pointer;
    float:left;
    margin-right: 20px;
}
.exportClass {
    cursor:pointer;
    align-content: end;
    color:green;
}
</style>